import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
    AbstractControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';

const TFR_DECLARATION_OPTIONS = ['firstTime', 'alreadyInCompany', 'ransom', 'notRansom'] as const;

export type TfrDeclarationOption = (typeof TFR_DECLARATION_OPTIONS)[number];

export const tfrDeclarationOptionsValidator: ValidatorFn = (
    control: AbstractControl,
): ValidationErrors | null => {
    const hasSelectedOption = Boolean(control.get('tfrPrimaryChoice')?.value);

    return hasSelectedOption ? null : { tfrDeclarationOptionRequired: true };
};

@Component({
    selector: 'tfr-declaration',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        CheckboxModule,
        RadioButtonModule,
    ],
    templateUrl: './tfr-declaration.component.html',
    styleUrls: ['./tfr-declaration.component.scss'],
    standalone: true,
})
export class TfrDeclarationComponent {
    @Input() form: FormGroup;

    readonly options: readonly TfrDeclarationOption[] = TFR_DECLARATION_OPTIONS;

    isFirstTimeSelected(): boolean {
        return this.form.get('tfrPrimaryChoice')?.value === 'firstTime' || this.form.get('firstTime')?.value === true;
    }

    selectOption(selectedOption: TfrDeclarationOption): void {
        this.options.forEach((option: TfrDeclarationOption): void => {
            this.form.get(option)?.setValue(option === selectedOption, { emitEvent: false });
        });
        this.form.get('tfrPrimaryChoice')?.setValue(selectedOption);

        if (selectedOption !== 'firstTime') {
            this.form.get('inCompany')?.setValue(false, { emitEvent: false });
        }

        this.form.updateValueAndValidity();
    }
}
